import { CSSProperties } from 'react';
import Button from '../../../../components/atoms/Button';

interface FavoriteButtonProps {
  className?: string;
  favorited: boolean;
  iconOnly?: boolean;
  text?: boolean;
  style?: CSSProperties | undefined;
  onFavorite: () => void;
  onUnfavorite: () => void;
}

const FavoriteButton = ({
  className,
  favorited,
  iconOnly,
  text,
  style,
  onFavorite,
  onUnfavorite,
}: FavoriteButtonProps) => {
  return (
    <Button
      dataDurableId={favorited ? 'favoriteButton' : 'unfavoriteButton'}
      className={className}
      icon="heart"
      iconClassName={!favorited && 'fill-current'}
      type={iconOnly ? 'icon-only' : 'navy'}
      text={text ? (favorited ? 'Unfavorite' : 'Favorite') : ''}
      onClick={favorited ? onUnfavorite : onFavorite}
      style={style}
    />
  );
};

export default FavoriteButton;
